import React, { useEffect, useState } from "react";
import KeywordPad from "./components/KeywordPad";
// Chakra imports
import {
  Box,
  Badge,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  useColorModeValue,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Checkbox,
  Tooltip,
  Icon,
  Alert,
  AlertIcon,
  Stack,
  HStack,
  IconButton
} from "@chakra-ui/react";
import { MdViewList, MdViewModule } from "react-icons/md";

// Custom components
import HistoryItem from "views/admin/Uncrawled/components/HistoryItem";
import XProducts from "views/admin/Uncrawled/components/Xproducts";
import { pairwisePrefixPatterns } from "./components/pairwisePrefixPatterns";
import WhitelistedProduct from 'views/admin/Detected Product/components/WhitelistedProduct';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';

import Card from "components/card/Card.js";
import { useListContext } from '../../../contexts/listContext';
import { useProductStore } from "../../../store/useProductStore"
import Loader from "../../../components/loader/Loader";
import SuggestionModal from "./components/SuggestionModal"; // Add this import

import { MdCheckCircle, MdCancel, MdOutlineError, MdShoppingCart, MdContentCopy, MdAlbum } from "react-icons/md";
import { InfoIcon, InfoOutlineIcon } from "@chakra-ui/icons";

export default function Products() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [masterList, setMasterList] = useState([]);

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const userInfo = JSON.parse(localStorage.getItem('PAuser'));
  const [productsToShow, setProductsToShow] = useState(20);
  const [viewMode, setViewMode] = useState("grid");
  // const [productsToShow, setProductsToShow] = useState(20);
  const productsPerPage = 20;
  const {
    products,
    moveProducts,
    updateProducts,
    updateProductField
  } = useProductStore();

  const isAdmin = userInfo?.message?.isAdmin || false;
  const uid = userInfo?.result?.id
  const [productByStatus, setProductByStatus] = useState([]);
  const [insertSeller, setInsertSeller] = useState([]);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [xStatusProducts, setXStatusProducts] = useState([]);
  const [filteredXProducts, setFilteredXProducts] = useState([]);
  const { list, checkedPlatforms, verificationStatus, checkedTextStatus, checkedTextAIStatus } = useListContext();
  const [isChecked, setIsChecked] = useState(false);
  const [selectedAll, setSelectedAll] = useState(false);
  const [first, setFirst] = useState(true);
  const [selectedProds, setSelectedProds] = useState([]);
  const [status, setStatus] = useState('');
  const [text, setText] = useState("");
  const [toggleX, setToggleX] = useState(false);
  const [toggleOg, setToggleOg] = useState(false);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false)

  const [successAlert, setSuccesAlert] = useState('');
  const [failureAlert, setFailureAlert] = useState('');
  const [suggestions, setSuggestions] = useState(null);
  const [isSuggestionModalOpen, setIsSuggestionModalOpen] = useState(false);
  const [selectedKeywordId, setSelectedKeywordId] = useState(null);
  const [accumulatedKeywords, setAccumulatedKeywords] = useState({}); // Store all accumulated keywords by keyword_id
  const [accumulatedKeywordsByStatus, setAccumulatedKeywordsByStatus] = useState({}); // { 'X': {...}, 'A': {...} }
  const [isKeywordPadOpen, setIsKeywordPadOpen] = useState(false); // Control pad visibility
  const [accumulatedCount, setAccumulatedCount] = useState(0); // Badge count for accumulated keywords
  const [accumulatedCountByStatus, setAccumulatedCountByStatus] = useState({}); // { 'X': 5, 'A': 3 }
  const [selectedXProducts, setSelectedXProducts] = useState([]);
  const [isUpdatingXProducts, setIsUpdatingXProducts] = useState(false);
  // Inside Parent Component
  const [approvedTags, setApprovedTags] = useState([]); // Array of { name: string, count: number }
  const [selectedTagFilter, setSelectedTagFilter] = useState(null); // To filter products by tag
  // const [isTitleCheckOnline, setIsTitleCheckOnline] = useState(false);

  const handleSuccessAlert = async (alertMessage) => {
    setSuccesAlert(alertMessage);
    setTimeout(() => {
      setSuccesAlert('');
    }, 5000);
  }
  const handleFailureAlert = async (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert('');
    }, 5000);
  }

  const fetchProducts = async () => {
    try {
      setIsLoading(true)
      const response = await fetch(`${backendUrl}/api/products/uncrawled`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id
        })
      });
      const json = await response.json();
      if (response.ok) {
        updateProducts(json.verifiedData, 'uncrawled');
        setSortedProducts(json.verifiedData);
      } else if (response.status === 400) {
        handleFailureAlert(json.message);
      }
    } catch (e) {
      console.error("Error in fetchProducts", e);
    } finally {
      setIsLoading(false)
    }
  };

  const fetchXStatusProducts = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${backendUrl}/api/products/Xstatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id
        })
      });
      const json = await response.json();
      if (response.ok) {
        setXStatusProducts(json);
        setFilteredXProducts(json);
        handleSuccessAlert("Uncrawled products loaded");
      } else if (response.status === 400) {
        handleFailureAlert(json.message);
      }
    } catch (e) {
      console.error("Error in fetchXStatusProducts", e);
      handleFailureAlert("Error fetching uncrawled products");
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    const newNo = productsToShow + productsPerPage;
    setProductsToShow(newNo);
    if (isChecked) {
      const newIds = sortedProducts.slice(0, newNo).map((item) => ({ pd_id: item.pd_id, title: item.title, keyword_id: item.keyword_id }));
      setInsertSeller(newIds);
      setSelectedAll(true);
    }
  };

  const loadLess = () => {
    const newNo = Math.max(productsToShow - productsPerPage, 0);
    setProductsToShow(newNo);
    if (isChecked) {
      const newIds = sortedProducts.slice(0, newNo).map((item) => ({ pd_id: item.pd_id, title: item.title, keyword_id: item.keyword_id }));
      setInsertSeller(newIds);
      setSelectedAll(true);
    }
  };

  const loadMoreXProducts = () => {
    setProductsToShow(productsToShow + productsPerPage);
  };

  const loadLessXProducts = () => {
    setProductsToShow(Math.max(productsToShow - productsPerPage, 0));
  };

  useEffect(() => {
    if (!products["uncrawled"]) {
      fetchProducts();
    } else {
      setSortedProducts(products["uncrawled"]);
      handleFilter();
    }
  }, [userInfo?.message?.result.id, products["uncrawled"]]);


  const handleInsertSeller = async (pd_id, title, keyword_id) => {
    try {
      const existingIndex = await insertSeller.findIndex(item => item.pd_id === pd_id);

      if (existingIndex !== -1) {
        await setInsertSeller(prev => {
          const updatedSeller = [...prev];
          return updatedSeller;
        });
      } else {
        await setInsertSeller([...insertSeller, { pd_id, title, keyword_id }]);
      }
    } catch (err) {
      console.error('err in handleInserSeller', err)
    }
  }

  const removeFromInsert = async (pd_id) => {
    setInsertSeller((prev) =>
      prev.filter((item) => item.pd_id !== pd_id)
    );
  };



  const handleSaveChanges = async () => {
    try {
      if (!status || insertSeller.length === 0) {
        handleFailureAlert("Please select a status and products");
        return;
      }
      setIsLoading(true);

      // Call handleGetSuggestions without awaiting to avoid blocking saveChanges

      const response = await fetch(`${backendUrl}/api/products/updateProducts/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          products: insertSeller,
          status: status,
          is_text: text,
          uid: uid,
          new_image_check: status === 'X' ? -1 : 6

        })
      });

      const json = await response.json();

      if (response.ok) {
        handleSuccessAlert("Status Updated");

        let updatedProducts = products["uncrawled"];

        if (status === 'X') {
          updatedProducts = updatedProducts.filter(p =>
            !insertSeller.some(sel => sel.pd_id === p.pd_id)
          );
        } else if (status === 'A' && text === '6') {
          updatedProducts = updatedProducts.map(p => {
            if (insertSeller.some(sel => sel.pd_id === p.pd_id)) {
              return { ...p, brand_image_check: 6 };
            }
            return p;
          });
        }

        products["uncrawled"] = updatedProducts
        setSortedProducts(updatedProducts);
        // if (isTitleCheckOnline) handleTitleCheckRAG();
        setInsertSeller([]);
        setStatus('');
        setText(undefined);
        setToggleX(false);
        setToggleOg(false);
        setIsChecked(false);

      } else {
        handleFailureAlert(json.message);
      }

    } catch (e) {
      console.error("Error in handleSaveChanges:", e);
      handleFailureAlert("Failed to save changes: " + e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async (text) => {
    try {
      if (text.length > 0) {
        handleFilter()
        const filteredList = masterList.filter((item) =>
          item.title?.toLowerCase().includes(text?.toLowerCase()) ||
          item.prod_code?.toLowerCase().includes(text?.toLowerCase())
        );
        setSortedProducts(filteredList);
      } else {
        handleFilter();
      }
    } catch (e) {
      console.error('error in search', e);
    }
  }

  const handleSearchXProducts = (text) => {
    try {
      if (text.length > 0) {
        const filteredList = xStatusProducts.filter((item) =>
          item.title?.toLowerCase().includes(text?.toLowerCase()) ||
          item.prod_code?.toLowerCase().includes(text?.toLowerCase()) ||
          item.keyword?.toLowerCase().includes(text?.toLowerCase())
        );
        setFilteredXProducts(filteredList);
      } else {
        setFilteredXProducts(xStatusProducts);
      }
    } catch (e) {
      console.error('error in search', e);
    }
  }

  const handleFilter = () => {
    try {
      let keywordNames = list.map((item) => item.name.toLowerCase());
      let platformIds = checkedPlatforms.map((item) => item.id);
      let verification = verificationStatus.map((item) => String(item.brand_image_check));
      let allProducts = products["uncrawled"] || [];
      let kfilter;
      let pfilter;
      let vfilter;
      let textStatus;

      kfilter = allProducts.filter((item) =>
        keywordNames.includes(item.keyword.toLowerCase())
      )
      pfilter = kfilter.filter((item) =>
        platformIds.includes(item.platform_id)
      )
      vfilter = pfilter.filter((item) => {
        const status = item.brand_image_check != null ? String(item.brand_image_check) : "null";
        return verification.includes(status);
      });

      if (checkedTextStatus.length > 0) {
        vfilter = vfilter.filter((item) => {
          const status = item.text_status != null ? item.text_status : "null"
          return checkedTextStatus.includes(String(status))
        })
      }
      if (checkedTextAIStatus.length > 0) {
        vfilter = vfilter.filter((item) => {
          const status = item.text_ai_status != null ? item.text_ai_status : "null"
          return checkedTextAIStatus.includes(String(status))
        })
      }


      setSortedProducts(vfilter);
      setMasterList(vfilter);

    } catch (err) {
      console.error('error in handleFilter', err)
    }
  }

  useEffect(() => {
    handleFilter();
  }, [list, checkedPlatforms, products["uncrawled"], verificationStatus, checkedTextStatus, checkedTextAIStatus]);

  const handleSelectAll = (items) => {
    setIsChecked(!isChecked);
    setFirst(false);
    if (!isChecked) {
      const newIds = items.map((item) => ({ pd_id: item.pd_id, title: item.title?.slice(0, 30), keyword_id: item.keyword_id }));
      setInsertSeller(newIds);
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
      setInsertSeller([]);
    }
  };

  const handleToggleX = async () => {
    setToggleX(!toggleX);
    setToggleOg(false);
    if (!toggleX) {
      setStatus('X');
      setText("-1")
    } else {
      setStatus('');
      setText()
    }
  }


  const handleToggleOg = () => {
    const newToggle = !toggleOg;
    setToggleOg(newToggle);
    setToggleX(false);
    const newStatus = newToggle ? 'A' : '';
    const newText = newToggle ? "6" : undefined;
    setStatus(newStatus);
    setText(newText);
  };

  const handleToggleXProduct = (pd_id) => {
    setSelectedXProducts((prev) => {
      const exists = prev.some((item) => item.pd_id === pd_id);
      if (exists) {
        return prev.filter((item) => item.pd_id !== pd_id);
      } else {
        const product = filteredXProducts.find((p) => p.id === pd_id);
        // console.log("fkkf",filteredXProducts)
        return [...prev, { pd_id: product.id, title: product.title?.slice(0, 30), keyword_id: product.keyword_id }];
      }
    });
  };

  const handleSelectAllXProducts = (products) => {
    setIsChecked(!isChecked);
    setFirst(false);
    if (!isChecked) {

      const newIds = products.map((item) => ({ pd_id: item.id, title: item.title?.slice(0, 30) }));
      setSelectedXProducts(newIds);
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
      setSelectedXProducts([]);
    }
  };

  const handleSaveXProductsChanges = async () => {
    if (selectedXProducts.length === 0) {
      handleFailureAlert("Please select at least one product");
      return;
    }

    try {
      setIsUpdatingXProducts(true);

      const response = await fetch(`${backendUrl}/api/products/updateProducts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          products: selectedXProducts,
          status: "A",
        }),
      });

      if (response.ok) {
        handleSuccessAlert(`${selectedXProducts.length} product(s) updated successfully`);

        // Append selected X products to uncrawled products
        const productsToAdd = selectedXProducts.map(selected => {
          return filteredXProducts.find(p => p.id === selected.pd_id);
        }).filter(p => p);

        // Step 1: Update store reference FIRST
        const updatedUncrawled = [...(products["uncrawled"] || []), ...productsToAdd];
        products["uncrawled"] = updatedUncrawled;

        // Step 2: Sync Zustand store
        updateProducts(updatedUncrawled, 'uncrawled');

        // Step 3: Call handleFilter() to apply filters and update both masterList and sortedProducts
        handleFilter();

        setSelectedXProducts([]);
        fetchXStatusProducts();
      } else {
        handleFailureAlert("Failed to update products");
      }
    } catch (error) {
      console.error("Error updating products:", error);
      handleFailureAlert("Error updating products");
    } finally {
      setIsUpdatingXProducts(false);
    }
  };
  return (
    <>
  

      <Tabs colorScheme='messenger' pt={{ base: "180px", md: "80px", xl: "80px" }}>
        <Flex justify="space-between" align="center">
          <TabList>
            <Tab border="transparent">All Products</Tab>
            <Tab border="transparent" onClick={() => { fetchXStatusProducts() }}>Uncrawled (X-Status)</Tab>
          </TabList>

        </Flex>

        <TabPanels>
          {/* Tab 1: All Products */}
          <TabPanel>
            <Box>
              {isLoading && <Loader />}
              <Card p='0px' w='100%'>
                <Flex px='20px' pt='10px' justify="space-between" align="center">

                  <Text px='20px' pt='10px'>Total Products: {sortedProducts.length}</Text>
                  <HStack spacing={2} pr="20px">
                    <IconButton
                      icon={<MdViewList />}
                      isActive={viewMode === 'list'}
                      onClick={() => setViewMode('list')}
                      aria-label="List View"
                    />
                    <IconButton
                      icon={<MdViewModule />}
                      isActive={viewMode === 'grid'}
                      onClick={() => setViewMode('grid')}
                      aria-label="Grid View"
                    />
                  </HStack>
                </Flex>
                <Box
                  position="sticky"
                  top="95px"
                  zIndex="10"
                  bg={useColorModeValue("white", "navy.800")} // Match your card's background
                  boxShadow="sm" // Optional: adds a shadow when scrolling
                  pb="10px"
                  rounded={10}
                >


                  <Flex
                    align={{ sm: "flex-start", lg: "center" }}
                    justify='space-between'
                    w='100%'
                    px='22px'
                    py='12px'>
                    <SearchBar mt="0px" borderRadius="30px" onChange={(e) => { handleSearch(e.target.value) }} />
                    {isAdmin && (
                      <Flex alignSelf='right' gap='10px'>
                        <Text color={textColor}
                          fontSize={{
                            base: "md",
                          }}
                          fontWeight='bold'
                          m="10px"
                          mr='5px'>Select all ({insertSeller.length})</Text>
                        <Checkbox
                          isChecked={isChecked}
                          onChange={() => handleSelectAll(sortedProducts.slice(0, productsToShow))}
                          mr='2vw'>
                        </Checkbox>
                        <Flex mr='2vw'>
                          <Tooltip label='Mark as Verified'>
                            <Button colorScheme='gray' fontSize="20px" p='0px' onClick={() => handleToggleOg()}>
                              <Icon as={MdCheckCircle} color={toggleOg === true ? 'green' : 'gray'} />
                            </Button>
                          </Tooltip>
                          <Tooltip label='Remove'>
                            <Button colorScheme="gray" fontSize="20px" p='0px' onClick={() => handleToggleX()}>
                              <Icon as={MdCancel} color={toggleX === true ? 'red' : 'gray'} />
                            </Button>
                          </Tooltip>
                        </Flex>
                        <Button variant='action' onClick={() => { handleSaveChanges() }}>Save Changes</Button>
                      </Flex>
                    )}
                  </Flex>
  
                </Box>
                <SimpleGrid
                  columns={viewMode === 'grid' ? { base: 1, md: 2, lg: 3, xl: 4 } : 1}
                  spacing={viewMode === 'grid' ? "20px" : "0px"}
                  p={viewMode === 'grid' ? "20px" : "0px"}
                >


                  {sortedProducts
                    .filter(prod => {
                      if (!selectedTagFilter) return true;
                      // Show if title starts with the tag name
                      return prod.title?.toLowerCase().startsWith(selectedTagFilter.toLowerCase());
                    }).slice(0, productsToShow)
                    .map((prod, index) => {
                      return (
                        <HistoryItem
                          key={prod.pd_id}
                          index={index}
                          product={prod}
                          handleInsertSeller={handleInsertSeller}
                          removeFromInsert={removeFromInsert}
                          selectAll={selectedAll}
                          insertSeller={insertSeller}
                          first={first}
                          isAdmin={isAdmin}
                          viewMode={viewMode}

                        />
                      )
                    })}
                </SimpleGrid>
              </Card>

              <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadLess()} r='0' position='absolute' right={{ base: '10%', md: '15%', sm: '30%' }} textDecoration='underline'>
                Show less...
              </Text></Link>
              <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadMore()} r='0' position='absolute' right={{ base: '2%', md: '5%' }} textDecoration='underline'>
                Show more...
              </Text></Link>
            </Box>
          </TabPanel>

          {/* Tab 2: X-Status Products */}
          <TabPanel>
            <Box>
              {isLoading && <Loader />}
              <Card p='0px' w='100%'>
                <Text px='20px' pt='10px'>Total X-Status Products: {filteredXProducts.length}</Text>
                <Flex
                  align={{ sm: "flex-start", lg: "center" }}
                  justify='space-between'
                  w='100%'
                  px='22px'
                  py='18px'>
                  <SearchBar
                    m="10px"
                    mt="0px"
                    borderRadius="30px"
                    onChange={(e) => handleSearchXProducts(e.target.value)}
                    placeholder="Search by title, code, or keyword"
                  />
                  {isAdmin && (
                    <Flex gap='10px'>
                      <Checkbox
                        isChecked={selectedXProducts.length === filteredXProducts.slice(0, productsToShow).length && filteredXProducts.slice(0, productsToShow).length > 0}
                        onChange={() => handleSelectAllXProducts(filteredXProducts.slice(0, productsToShow))}
                      />
                      <Text color={textColor}
                        fontSize={{
                          base: "md",
                        }}
                        fontWeight='bold'
                        m="10px"
                        mr='5px'>Select all ({selectedXProducts.length})</Text>

                      <Tooltip label='Change Status to A'>

                        <Button
                          variant='action'
                          onClick={handleSaveXProductsChanges}
                          isLoading={isUpdatingXProducts}
                        >
                          Save Changes
                        </Button>
                      </Tooltip>
                    </Flex>
                  )}
                </Flex>

                {filteredXProducts && filteredXProducts.slice(0, productsToShow).map((product, index) => (
                  <XProducts
                    key={index}
                    index={index}
                    product={product}
                    handleToggleProduct={handleToggleXProduct}
                    selectedProducts={selectedXProducts}
                    isAdmin={isAdmin}
                  />
                ))}
              </Card>

              {filteredXProducts.length > productsPerPage && (
                <>
                  <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadLessXProducts()} r='0' position='absolute' right={{ base: '10%', md: '15%', sm: '30%' }} textDecoration='underline'>
                    Show less...
                  </Text></Link>
                  <Link ><Text color={textColor} fontSize='l' fontWeight='500' onClick={() => loadMoreXProducts()} r='0' position='absolute' right={{ base: '2%', md: '5%' }} textDecoration='underline'>
                    Show more...
                  </Text></Link>
                </>
              )}
            </Box>
          </TabPanel>
        </TabPanels>

        <Stack spacing={3} position='fixed' right='10px' bottom='2vh'>
          {successAlert !== '' &&
            <Alert status='success' variant='left-accent' w='40vw'  >
              <AlertIcon />
              {successAlert}
            </Alert>
          }
          {failureAlert !== '' &&
            <Alert status='error' variant='left-accent' w='40vw'>
              <AlertIcon />
              {failureAlert}
            </Alert>
          }
        </Stack>
      </Tabs>
    </>
  );
}
